import {
    CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS,
    CHANGE_APPLICATION_POLICY_SETTINGS,
    CLOSE_AD_MODAL,
    CREATE_ADVANCED_DISBURSEMENT,
    EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_CREATE_ADVANCED_DISBURSEMENT,
    FAILED_TO_EDIT_ADVANCE_DISBURSEMENT,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
    FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
    GET_ADVANCE_DISBURSEMENT_BY_ID,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED,
    GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS,
    GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES, GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED,
    GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS,
    GET_ADVANCE_DISBURSEMENTS_STATUSES,
    GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    GET_ALL_ADVANCED_DISBURSEMENTS,
    GET_APPLICATION_AD_UPDATE_STATUS,
    GET_APPLICATION_AD_UPDATE_STATUS_FAIL,
    GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS, LOGOUT,
    RECEIVE_ADVANCE_DISBURSEMENT_BY_ID,
    RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES,
    RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS,
    RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY,
    RECEIVE_ALL_ADVANCED_DISBURSEMENTS,
    RECEIVE_CREATE_ADVANCED_DISBURSEMENT,
    RECEIVE_EDIT_ADVANCE_DISBURSEMENT,
    RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM,
    RECEIVE_POST_UPDATE_POLICY_FORM
} from "../actions";
import {LOCATION_CHANGE} from "connected-react-router";

const defaultState = {
    advanceDisbursementsStatuses: [],
    fetchingStatuses: false,
    advanceDisbursementsRejectionReasons: [],
    fetchingRejectionReasons: false,
    advancedDisbursements: [],
    posting: false,
    fetching: false,
    totalAppliedRecords: 0,
    totalAppliedValue: 0,
    totalApprovedRecords: 0,
    totalApprovedValue: 0,
    totalRecords: 0,
    totalSettledRecords: 0,
    totalPartSettledRecords:0,
    totalPartSettledValue: 0,
    totalSettledValue: 0,
    totalValue: 0,
    totalPaidRecords: 0,
    totalPaidValue: 0,
    totalRejectedValue: 0,
    totalRejectedRecords: 0,
    totalProcessingRecords: 0,
    totalProcessingValue: 0,
    fetchingById: false,
    advanceDisbursementById: {},
    patching: false,
    fetchingUpdateStatus: false,
    shouldUpdate: false,
    advancedDisbursementsDueForPayment: [],
    fetchingADDueForPayment: false,
    fetchAdsDueForPaymentErrorMessage: null,
    fetchingStatementMessages: false,
    statementMessages: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES:
            return {
                ...state,
                fetchingStatementMessages: true
            };
        case GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_SUCCESS:
            return {
                ...state,
                fetchingStatementMessages: false,
                statementMessages: action.payload.body
            };
        case GET_ADVANCE_DISBURSEMENTS_STATEMENT_MESSAGES_FAILED:
            return {
                ...state,
                fetchingStatementMessages: false
            };
        case GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT:
            return {
                ...state,
                fetchingADDueForPayment: true,
                fetchAdsDueForPaymentErrorMessage: null
            };
        case GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_SUCCESS:
            return {
                ...state,
                fetchingADDueForPayment: false,
                advancedDisbursementsDueForPayment: action.payload.body.data
            };
        case GET_ADVANCE_DISBURSEMENTS_DUE_FOR_PAYMENT_FAILED:
            let adsDueForPaymentMessage = '';
            try {
                adsDueForPaymentMessage = action.payload.response.body.message;
            } catch (e) {
                adsDueForPaymentMessage = 'Failed to fetch advance disbursements due for payment';
            }
            return {
                ...state,
                fetchingADDueForPayment: false,
                fetchAdsDueForPaymentErrorMessage: adsDueForPaymentMessage
            };
        case RECEIVE_POST_UPDATE_POLICY_FORM:
            return {
                ...state,
                shouldUpdate: defaultState.shouldUpdate
            };
        case RECEIVE_POST_NO_CHANGES_UPDATE_POLICY_FORM:
            return {
                ...state,
                shouldUpdate: defaultState.shouldUpdate
            };
        case CHANGE_APPLICATION_POLICY_SETTINGS:
            return {
                ...state,
                shouldUpdate: defaultState.shouldUpdate
            };
        case GET_APPLICATION_AD_UPDATE_STATUS:
            return {
                ...state,
                fetchingUpdateStatus: true
            };
        case GET_APPLICATION_AD_UPDATE_STATUS_SUCCESS:
            let shouldUpdate = false;
            try {
                shouldUpdate = action.payload.body
            }
            catch (e) {
                shouldUpdate = false;
            }
            return {
                ...state,
                fetchingUpdateStatus: false,
                shouldUpdate: shouldUpdate
            };
        case GET_APPLICATION_AD_UPDATE_STATUS_FAIL:
            return {
                ...state,
                fetchingUpdateStatus: false,
                shouldUpdate: defaultState.shouldUpdate
            };
        case GET_ADVANCE_DISBURSEMENTS_STATUSES:
            return {
                ...state,
                fetchingStatuses: true
            };
        case RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES:
            return {
                ...state,
                fetchingStatuses: false,
                advanceDisbursementsStatuses: action.payload.body
            };
        case FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_STATUSES:
            return {
                ...state,
                fetchingStatuses: false
            };
        case GET_ADVANCE_DISBURSEMENTS_REJECTION_REASONS:
            return {
                ...state,
                fetchingRejectionReasons: true
            };
        case RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS:
            let advanceDisbursementsRejectionReasons = action.payload.body
            .map(i => ({
                key: i.machineName,
                value: i.name
            }));
            
            advanceDisbursementsRejectionReasons.unshift({key: '', value: ''});
            
            return {
                ...state,
                fetchingRejectionReasons: false,
                advanceDisbursementsRejectionReasons: advanceDisbursementsRejectionReasons
            };
        case FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENTS_REJECTION_REASONS:
            return {
                ...state,
                fetchingRejectionReasons: false
            };
        case EDIT_ADVANCE_DISBURSEMENT:
            return {
                ...state,
                patching: true
            };
        case RECEIVE_EDIT_ADVANCE_DISBURSEMENT:
            let newAd = [];
            newAd = state.advancedDisbursements.map(ad => {
                if(ad.id === action.payload.body.id){
                    return action.payload.body;
                }
                return ad;
            });
            return {
                ...state,
                patching: false,
                advanceDisbursementById: defaultState.advanceDisbursementById,
                advancedDisbursements: newAd
            };
        case FAILED_TO_EDIT_ADVANCE_DISBURSEMENT:
            return {
                ...state,
                patching: false
            };
        case CLOSE_AD_MODAL:
            return {
                ...state,
                advanceDisbursementById: defaultState.advanceDisbursementById,
                shouldUpdate: defaultState.shouldUpdate
            };
        case GET_ADVANCE_DISBURSEMENT_BY_ID:
            return {
                ...state,
                fetchingById: true
            };
        case RECEIVE_ADVANCE_DISBURSEMENT_BY_ID:
            if(!action.payload.body){
                return {
                    ...state,
                    fetchingById: false
                }
            }
            return {
                ...state,
                fetchingById: false,
                advanceDisbursementById: action.payload.body,
            };
        case FAILED_TO_RECEIVE_ADVANCE_DISBURSEMENT_BY_ID:
            return {
                ...state,
                fetchingById: false,
                advanceDisbursementById: defaultState.advanceDisbursementById
            };
        case GET_ADVANCED_DISBURSEMENTS_OF_A_POLICY:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY:
            return {
                ...state,
                fetching: false,
                advancedDisbursements: action.payload.body.data,
                totalAppliedRecords: action.payload.body.totalAppliedRecords,
                totalAppliedValue: action.payload.body.totalAppliedValue,
                totalApprovedRecords: action.payload.body.totalApprovedRecords,
                totalApprovedValue: action.payload.body.totalApprovedValue,
                totalSettledRecords: action.payload.body.totalSettledRecords,
                totalPartSettledRecords: action.payload.body.totalPartSettledRecords,
                totalSettledValue: action.payload.body.totalSettledValue,
                totalPartSettledValue: action.payload.body.totalPartSettledValue,
                totalRejectedValue: action.payload.body.totalRejectedValue,
                totalRejectedRecords: action.payload.body.totalRejectedRecords,
                totalRecords: action.payload.body.totalRecords,
                totalValue: action.payload.body.totalValue,
                totalProcessingRecords: action.payload.body.totalProcessingRecords,
                totalProcessingValue: action.payload.body.totalProcessingValue,
                totalPaidRecords: action.payload.body.totalPaidRecords,
                totalPaidValue: action.payload.body.totalPaidValue
            };
        case FAILED_TO_RECEIVE_ADVANCED_DISBURSEMENTS_OF_A_POLICY:
            return {
                ...state,
                fetching: false
            };
        case GET_ALL_ADVANCED_DISBURSEMENTS:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_ALL_ADVANCED_DISBURSEMENTS:
            return {
                ...state,
                fetching: false,
                advancedDisbursements: action.payload.body.data,
                totalAppliedRecords: action.payload.body.totalAppliedRecords,
                totalAppliedValue: action.payload.body.totalAppliedValue,
                totalApprovedRecords: action.payload.body.totalApprovedRecords,
                totalApprovedValue: action.payload.body.totalApprovedValue,
                totalRecords: action.payload.body.totalRecords,
                totalValue: action.payload.body.totalValue,
                totalSettledRecords: action.payload.body.totalSettledRecords,
                totalSettledValue: action.payload.body.totalSettledValue,
                totalRejectedValue: action.payload.body.totalRejectedValue,
                totalRejectedRecords: action.payload.body.totalRejectedRecords,
                totalProcessingRecords: action.payload.body.totalProcessingRecords,
                totalProcessingValue: action.payload.body.totalProcessingValue,
                totalPaidRecords: action.payload.body.totalPaidRecords,
                totalPaidValue: action.payload.body.totalPaidValue,
                totalPartSettledRecords: action.payload.body.totalPartSettledRecords,
                totalPartSettledValue: action.payload.body.totalPartSettledValue
            };
        case FAILED_TO_RECEIVE_ALL_ADVANCED_DISBURSEMENTS:
            return {
                ...state,
                fetching: false
            };
        case CREATE_ADVANCED_DISBURSEMENT:
            return {
                ...state,
                posting: true
            };
        case RECEIVE_CREATE_ADVANCED_DISBURSEMENT:
            return {
                ...state,
                posting: false
            };
        case FAILED_TO_CREATE_ADVANCED_DISBURSEMENT:
            return {
                ...state,
                posting: false
            };
        case CHANGE_ADVANCE_DISBURSEMENTS_STORE_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        case LOCATION_CHANGE:
            return defaultState;
        case LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
